import axios from '@/lib/AxApi';

export default {
  getOrdinations(params, cb)
  {
    params.type = 'ordination';
    axios.get('/rest/User_companies/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  saveOrdination(params, cb)
  {
    params.type = 'ordination';
    if(typeof params.id != 'undefined' && params.id != '')
    {
      axios.post('/rest/User_companies/updateRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
    else
    {
      axios.post('/rest/User_companies/insertRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
  },
  deleteOrdination(params, cb)
  {
    axios.post('/rest/User_companies/deleteRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/ordinations.js